import { useEffect, useRef, useCallback } from 'react';
import moment from 'moment';

/**
 * 特殊行政
 */

function isOnlyNo(str) {
  str  =str.replaceAll(" ","");
  if(Number(str)+'' ==NaN+'' || Number(str)==0 ){
      return false;
      console.log('是纯数字')
  }else{
      return true;
      console.log('不是纯数字')
  }
}

function IsEmail(str) {
  if(str.indexOf(' ')>=0){
      return false;
  }
 var reg=/^(\w+([-.][A-Za-z0-9]+)*){1,18}@\w+([-.][A-Za-z0-9]+)*\.\w+([-.][A-Za-z0-9]+)*$/;
 return reg.test(str);
}


function IsPhone(str) {
  if(str.indexOf(' ')>=0){
      return false;
  }
 var reg=/^1[3456789]\d{9}$/;
 return reg.test(str);
}



function countryArrFun() {
  return [
    '北京市',
    '天津市',
    '上海市',
    '重庆市',
    '香港特别行政区',
    '澳门特别行政区',
  ];
}
/** 时间段1
 * @param n1 开始时间
 * @param n2 结束时间
 *
 * @returns 聚合时间段
 */
function timeSlot(n1, n2) {
  let _time = "";
  let time1 = moment(n1).format("YYYY.MM.DD");
  let time2 = moment(n2).format("YYYY.MM.DD");
  // 同一天的时间段显示
  if (time1 == time2) {
    _time = `${moment(n1).format("YYYY.MM.DD HH:mm")}-${moment(n2).format(
      "HH:mm"
    )}`;
  } else {
    _time = `${moment(n1).format("YYYY.MM.DD")}-${moment(n2).format("MM.DD")}`;
    // 隔天的时间段显示《时分》相同 (因为一个时间段隔天显示有问题的。)
    // if (moment(n1).format("HH:mm") == moment(n2).format("HH:mm")) {
    //   _time = `${moment(n1).format("YYYY.MM.DD")}-${moment(n2).format(
    //     "MM.DD"
    //   )} ${moment(n1).format("HH:mm")}`;
    // } else {
    //   _time = `${moment(n1).format("YYYY.MM.DD")}-${moment(n2).format(
    //     "MM.DD"
    //   )}`;
    // }
  }
  return _time;
}

/** 链接拼接方法。
 * @param url 页面链接
 * @param params 需要传递的参数的obj
 */
const queryString = (url, params) => {
  // 没有 query 参数时，直接返回
  let objKey = [];
  if (params) {
    objKey = Object.keys(params);
  }
  if (objKey.length == 0) {
    return url;
  }
  // 有 query 参数
  let queryAry = [];
  Object.keys(params).map(v => {
    queryAry.push(`${v}=${params[v]}`);
  });
  return url + '?' + queryAry.join('&');
};


/**
 * 去除接口请求的时候有 undefined、null、0等数据
 */
const handleParmas = (params: any) => {
  let ObjKey = Object.keys(params);
  let _parmas: any = {};
  ObjKey.forEach(item => {
    if (params[item]) {
      _parmas[item] = params[item];
    };
  });

  return _parmas;
};



// 获取链接上所有参数
const getUrlParams = ()=>{
  var urlArr = window.location.href.split('?'); //获取url中"?"符后的字串
  
  var url = '';
  if (urlArr.length>1) { 
    url = "?"+urlArr[1];
  };
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    var strs = str.split("&");
    for(var i = 0; i < strs.length; i ++) {
      theRequest[strs[i].split("=")[0]]=decodeURIComponent((strs[i].split("=")[1]));
    }
  };
  return theRequest;
}

// 判断设备为 ios
function isIos() {
  var u = navigator.userAgent;
  if (u.indexOf('iPhone') > -1 || u.indexOf('iOS') > -1) {
    return true;
  }
  return false;
}

// 随机数生成
const randomString = (len) => {
  len = len || 32;
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';/****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var pwd = '';
  for (var i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  };
  return pwd;
};

/**
  *
  * @param fn {Function}   实际要执行的函数
  * @param delay {Number}  延迟时间，也就是阈值，单位是毫秒（ms）
  * @param dep 未知
  * 
  * @return {Function}     返回一个“去弹跳”了的函数
  */
function useDebounce(fn, delay, dep = []) {
  const { current } = useRef({ fn, timer: null });
  useEffect(function () {
    current.fn = fn;
  }, [fn]);

  return useCallback(function f(...args) {
    if (current.timer) {
      clearTimeout(current.timer);
    }
    current.timer = setTimeout(() => {
      current.fn.call(this, ...args);
    }, delay);
  }, dep)
}

export { countryArrFun, queryString, handleParmas,getUrlParams, isIos, randomString, timeSlot, useDebounce,IsPhone,IsEmail,isOnlyNo };
